import leadGenerationForm from 'a_root-folder/lib/service/modal/templates/leadGeneration';
import HelpService from "a_root-folder/lib/service/help.service";
import {STATIC_DOMAIN} from "a_root-folder/lib/e3plan-3d/modules/constants";

export default class LeadGeneration{
    constructor(modalService, translate) {
        this._modalService =  modalService;
        this._translate =  translate;
        this._helperService = new HelpService();
    }

    get isOpen() {
        return this._modalService.checkIfModalPresent('lead-generation');
    }

    hide() {
        if (this._modalService.checkIfModalPresent('lead-generation')) {
            this._modalService._removeModal('lead-generation');
        }
    }

    show(onClose=()=>{}) {
        return new Promise((res, rej) => {
            try{
                this._modalService.showCreatedModal('lead-generation', leadGenerationForm(this._translate, (data) => {
                    res(data);
                }), true, {
                    'chat-modal-close': () => {
                        onClose();
                    }
                });
            }catch (e){
                rej(e)
            }
        })
    }

    sendToAgents(str) {
        const {leadgen_url} = this._helperService;

        return this._helperService.get(`${leadgen_url}?${str}`);
    }

    emailTemplate({tourName, comments, email, phone, name}){
        this._helperService.clearRoomId();
        const url = this._helperService.convertToUrl(this._helperService.urlParams);
        let str = '';

        const subject = `Missed call : ${tourName}`;
        const body = `<div style="color: #000000"><span style="color: #000000">${this._translate('Hello')}, </span><br\><span style="color: #000000">${this._translate('The person below tried to contact you regarding the')} <a href="${url}">${tourName}</a> ${this._translate('tour')}.</span> <br\> <span>${this._translate('Name')}: ${name} </span><br\> <span>${this._translate('Phone number')}: ${phone} </span><br\> <span>${this._translate('Email')}: ${email} </span><br\> <br\> <span>${this._translate('Comments')}: ${comments} </span><br\> <br\> <span>${this._translate('Thank you')}.</span></div>`;
        str += `subject=${encodeURIComponent(subject)}&`;
        str += `body=${encodeURIComponent(body)}&`;
        str += `url=${encodeURIComponent(url)}`;

        return str;
    }
}
